import COUNTRY_LIST from "constants/COUNTRY_LIST";

/**
 * Mapa para lookup O(1)
 */
const COUNTRY_MAP: Record<string, string> = COUNTRY_LIST.reduce(
  (acc, country) => {
    acc[country.value] = country.label;
    return acc;
  },
  {} as Record<string, string>,
);

/**
 * Retorna o nome do país a partir do código ISO-2
 */
export const getCountryName = (code?: string | null): string => {
  if (!code) return "-";

  return COUNTRY_MAP[code.toUpperCase()] ?? code;
};
